import { render, staticRenderFns } from "./SentHistory.vue?vue&type=template&id=73287ad1&scoped=true&"
import script from "./SentHistory.vue?vue&type=script&lang=js&"
export * from "./SentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73287ad1",
  null
  
)

export default component.exports